import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { SITE_APPS } from '../config/siteBranding';
import './AppSwitcher.css';

const APP_ORDER = [
  SITE_APPS.soccer,
  SITE_APPS.running,
  SITE_APPS.hiking,
  SITE_APPS.training,
  SITE_APPS.blog,
];

export function resolveActiveAppId(pathname = '') {
  if (pathname.startsWith('/blog')) return 'blog';
  if (
    pathname.startsWith('/training') ||
    pathname.startsWith('/soccer/training') ||
    pathname.startsWith('/soccer/public/training')
  ) {
    return 'training';
  }
  if (pathname.startsWith('/running')) return 'running';
  if (pathname.startsWith('/hiking')) return 'hiking';
  if (pathname.startsWith('/soccer')) return 'soccer';
  return null;
}

/**
 * App pills under Daily Sports Life: Soccer · Running · Hiking · Training · Blog
 * @param {'default' | 'onDark' | 'compact'} variant
 */
const AppSwitcher = ({ activeAppId, onNavigate, variant = 'default', className = '' }) => {
  const location = useLocation();
  const resolvedActive = activeAppId ?? resolveActiveAppId(location.pathname);

  return (
    <nav
      className={`app-switcher app-switcher--${variant}${className ? ` ${className}` : ''}`}
      aria-label="Daily Sports Life apps"
    >
      {APP_ORDER.map((app) => {
        const isActive = resolvedActive === app.id;
        return (
          <Link
            key={app.id}
            to={app.href}
            className={`app-switcher__link${isActive ? ' is-active' : ''}`}
            aria-current={isActive ? 'page' : undefined}
            onClick={onNavigate}
          >
            {app.shortLabel}
          </Link>
        );
      })}
    </nav>
  );
};

export default AppSwitcher;
